import { useRef } from 'react';

import { useIsClamped } from '@crm/shared/lib';
import { Badge } from '@crm/shared/ui/Badge';

export const DealCardBadge = ({ textContent }: { textContent: string }) => {
    const badgeRef = useRef<HTMLParagraphElement>(null);
    const isClamped = useIsClamped(badgeRef);
    return (
        <Badge className="max-w-17.5 rounded-lg text-[10px] font-normal">
            <span
                title={isClamped ? textContent : undefined}
                className="truncate"
                ref={badgeRef}
            >
                {textContent}
            </span>
        </Badge>
    );
};
